import CheckIcon from '@mui/icons-material/Check';
import {
  Typography,
  Card,
  CardContent,
  Grid,
  CardActionArea,
  Box,
} from '@mui/material';
import { includes } from 'lodash';
import React, { useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { IRREGULARITIES } from '../../routes';
import {
  fetchGetIrregularityById,
  irregularitiesSlice,
  useDispatch,
  useSelector,
} from '../../stores';
import { palette } from '../../theme';
import { handleApiReturn, handleDateTime } from '../../utils';

export const IrregularityCard = (props: {
  item:
    | {
        brand: string;
        id: number;
        observation: string | null;
        plate: string;
        plateImg: string;
        ticketImg: string | null;
        address: string | null;
        registerDateTime: string;
        type: string;
      }
    | undefined;
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { driverId } = useSelector((state) => state.profileReducer);
  const cardRef = useRef(null);

  const handleIrregularityClick = (irregularityId: string) => {
    dispatch(
      fetchGetIrregularityById({
        driverId: driverId.toString(),
        irregularityId: irregularityId,
      }),
    ).then((res: any) => {
      handleApiReturn(
        res,
        () => {
          dispatch(irregularitiesSlice.actions.toggleShowDetails());
          navigate(IRREGULARITIES);
        },
        null,
      );
    });
  };

  if (!props.item) {
    return null;
  }

  return (
    <Grid
      item
      sx={{
        position: 'relative',
        width: '100%',
        maxWidth: 700,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginBottom: '10px',
        margin: '10px',
      }}
    >
      <Card
        sx={{
          width: '100%',
          borderRadius: '14px',
          backgroundColor: 'white',
        }}
        ref={cardRef}
        onClick={() => handleIrregularityClick(props.item!.id.toString())}
      >
        <CardActionArea
          sx={{
            display: 'flex',
            flexDirection: {
              xs: 'column',
              sm: 'row',
            },
            height: {
              xs: 550,
              sm: 350,
            },
          }}
        >
          <CardContent
            sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'flex-start',
              alignItems: 'flex-start',
              padding: '20px',
              width: {
                xs: '100%',
                sm: '50%',
              },
              flex: '1',
              minWidth: 0,
              maxWidth: '100%',
              boxSizing: 'border-box',
            }}
          >
            <Typography variant='h6' color='primary'>
              {props.item.id}
            </Typography>
            <Typography
              gutterBottom
              color='text.secondary'
              sx={{
                fontSize: '16px',
              }}
            >
              {handleDateTime(props.item.registerDateTime)}
            </Typography>
            <Typography
              color='text.secondary'
              sx={{
                fontSize: '16px',
              }}
            >
              <strong>Placa:</strong> {props.item.plate}
            </Typography>
            <Typography
              color='text.secondary'
              sx={{
                fontSize: '16px',
              }}
            >
              <strong>Categoria:</strong> {props.item.type}
            </Typography>
            <Typography
              color='text.secondary'
              sx={{
                fontSize: '16px',
                width: '100%',
                whiteSpace: 'normal',
                wordBreak: 'break-word',
                overflowWrap: 'break-word',
              }}
            >
              <strong>Modelo:</strong> {props.item.brand}
            </Typography>
            {props.item.address && (
              <Typography
                color='text.secondary'
                sx={{
                  fontSize: '16px',
                  width: '100%',
                  whiteSpace: 'normal',
                  wordBreak: 'break-word',
                  overflowWrap: 'break-word',
                }}
              >
                <strong>Endereço:</strong> {props.item.address}
              </Typography>
            )}
          </CardContent>
          <Box
            sx={{
              width: {
                xs: '100%',
                sm: '50%',
              },
              height: '100%',
              display: 'flex',
              flexDirection: 'column',
              gap: '5px',
              flex: 1,
              overflow: 'hidden',
            }}
          >
            {/* Plate Image */}
            <Box
              sx={{
                flex: 1,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '100%',
                minHeight: 0,
                overflow: 'hidden',
              }}
            >
              {props.item.plateImg ? (
                <img
                  alt='placa'
                  src={props.item.plateImg}
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                  }}
                />
              ) : (
                <Box
                  sx={{
                    width: '100%',
                    height: '100%',
                    backgroundColor: 'rgba(0, 0, 0, 0.08)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <Typography
                    color='text.secondary'
                    sx={{
                      fontSize: '12px',
                      textAlign: 'center',
                    }}
                  >
                    Sem imagem da placa
                  </Typography>
                </Box>
              )}
            </Box>

            {/* Ticket Image */}
            <Box
              sx={{
                flex: 1,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '100%',
                minHeight: 0,
                overflow: 'hidden',
              }}
            >
              {props.item.ticketImg ? (
                <img
                  alt='multa'
                  src={props.item.ticketImg}
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                  }}
                />
              ) : (
                <Box
                  sx={{
                    width: '100%',
                    height: '100%',
                    backgroundColor: 'rgba(0, 0, 0, 0.08)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <Typography
                    color='text.secondary'
                    sx={{
                      fontSize: '12px',
                      textAlign: 'center',
                    }}
                  >
                    Sem imagem do ticket
                  </Typography>
                </Box>
              )}
            </Box>
          </Box>
        </CardActionArea>
      </Card>
    </Grid>
  );
};
